import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import {
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  IconButton,
  Box,
  CircularProgress,
  FormControl,
} from "@mui/material";
import OutlinedInput from "@mui/material/OutlinedInput";
import "bootstrap/dist/css/bootstrap.min.css";
import { base_url } from "../api/api-url";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SnackNotification from "../components/common/SnackNotification";
import { useLocation } from "react-router-dom";
import SearchBar from "../../src/components/common/SearchBar";
const StaffManagement = ({ userType }) => {
  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [viewStaff, setViewStaff] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [formData, setFormData] = useState({
    fullName: "",
    staffID: "",
    role: "",
    email: "",
    mobile: "",
    department: [],
    password: "",
    allowedModule:[]
  });
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");
  const location = useLocation();
  const roles =userType !== "user" ? ["Admin", "Manager", "TL", "Executive"] : ["User"];
  const [staffList, setStaffList] = useState([]);
  const [filteredStaffList, setFilteredStaffList] = useState([]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchDepartments();
    fetchStaff();
  }, [location.pathname]);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const fetchDepartments = async () => {
    try {
      const res = await fetch(`${base_url}/department`);
      const data = await res.json();
      setDepartments(data.data);
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

  const fetchStaff = async () => {
    try {
      const res = await fetch(`${base_url}/user-getAll`);
      let data = await res.json();
      let filterData;
      if (userType === "user") {
        filterData = data.data.filter(
          (staff) => staff.role.toLowerCase() === "user"
        );
      } else {
        filterData = data.data.filter(
          (staff) => staff.role.toLowerCase() !== "user"
        );
      }
      setStaffList(filterData);
      setFilteredStaffList(filterData);
    } catch (error) {
      console.error("Error fetching staff:", error);
    }
  };

  // Handle search results coming from SearchBar
  const handleSearch = (results) => {
    setFilteredStaffList(results);
    setPage(0); // Reset to first page when search changes
  };

  const handleShow = () => {
    setFormData({
      fullName: "",
      staffID: "",
      role: "",
      email: "",
      mobile: "",
      department: [],
      password: "",
    });
    setEditingIndex(null);
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);
  const handleViewClose = () => setShowViewModal(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (event) => {
    const selectedIds = event.target.value;
    const selectedDepartments = departments.filter((dep) =>
      selectedIds.includes(dep._id)
    );
    setFormData((prev) => ({ ...prev, department: selectedDepartments }));
  };
  const handleSave = async () => {
    let finalStaffID = formData.staffID;
    let finalRole=formData.role
    if (editingIndex === null) {
      const prefix = userType === "user" ? "U" : "EM";
      if (!finalStaffID.startsWith(prefix)) {
        finalStaffID = `${prefix}-${formData.staffID}`;
      }
      finalRole = finalRole || (userType === "user" ? "User" : "Admin");
    }

    const payload = {
      staffID: finalStaffID,
      fullName: formData.fullName,
      email: formData.email,
      mobile: formData.mobile,
      department: formData.department,
      role: finalRole,
      password: formData.password,
      allowedModule: [...formData.allowedModule,'viewticket'] || ['Dashboard','Tickets','Reports','viewticket'],
    };
    setLoading(true);

    try {
      let response;

      if (editingIndex !== null) {
        response = await fetch(`${base_url}/user-update/${formData.id}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
      } else {
        response = await fetch(`${base_url}/user-register`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
      }

      const result = await response.json();

      if (!response.ok) {
        // Show error message
        setSnackbarSeverity("error");
        setSnackbarMessage(result.message || "Failed to save staff");
        setSnackbarOpen(true);
        return;
      }

      // Success
      fetchStaff();
      handleClose();
      setSnackbarSeverity("success");
      setSnackbarMessage(
        editingIndex !== null
          ? "Staff updated successfully"
          : "Staff added successfully"
      );
      setSnackbarOpen(true);
    } catch (error) {
      console.error("Error saving staff:", error);
      setSnackbarSeverity("error");
      setSnackbarMessage("An unexpected error occurred");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (index) => {
    const selectedStaff = filteredStaffList[index];
    setFormData({
      id: selectedStaff._id,
      role: selectedStaff.role || "",
      staffID: selectedStaff.staffID || "",
      fullName: selectedStaff.fullName,
      email: selectedStaff.email,
      mobile: selectedStaff.mobile,
      department: selectedStaff.department || [],
      password: "",
      allowedModule: selectedStaff.allowedModule || ['Dashboard','Tickets','Reports','viewticket'],
    });
    setEditingIndex(index);
    setShowModal(true);
  };

  const handleDelete = async (index) => {
    const staffId = filteredStaffList[index]._id;
    if (window.confirm("Are you sure you want to delete this staff?")) {
      try {
        await fetch(`${base_url}/user-delete/${staffId}`, {
          method: "DELETE",
        });
        fetchStaff();
      } catch (error) {
        console.error("Error deleting staff:", error);
      }
    }
  };

  const handleView = async (staff) => {
    try {
      const res = await fetch(`${base_url}/user-getById/${staff._id}`);
      const data = await res.json();
      setViewStaff(data.data);
      setShowViewModal(true);
    } catch (error) {
      console.error("Error viewing staff:", error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div
      className="m-0 p-4 rounded shadow text-white"
      style={{ backgroundColor: "#1e1e1e", width: "100%" }}
    >
      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
        {userType === "user" ? (
          <h3>User Management</h3>
        ) : (
          <h3>Company Staff Management</h3>
        )}
        <Box
          sx={{
            display: "flex",
            gap: "10px",
            flexWrap: "wrap",
          }}
        >
          <SearchBar
            data={staffList}
            searchKeys={["fullName", "staffID", "email"]}
            onSearch={handleSearch}
            placeholder="Search staff..."
          />
          <Button
            style={{
              padding: "4px 10px",
              minHeight: "30px",
              fontSize: "0.8rem",
              fontWeight: "bold",
              lineHeight: 1.2,
              textTransform: "none",
            }}
            onClick={handleShow}
          >
            {userType === "user" ? "+ Add User" : "+ Add Staff"}
          </Button>
        </Box>
      </div>

      <TableContainer
        component={Paper}
        elevation={0}
        sx={{ backgroundColor: "transparent", width: "100%" }}
      >
        <Table sx={{ minWidth: 650 }}>
          <TableHead sx={{ backgroundColor: "white" }}>
            <TableRow>
              <TableCell>
                <strong>
                  {" "}
                  {userType === "user" ? "User ID" : "Employee ID"}
                </strong>
              </TableCell>
              <TableCell>
                <strong>Name</strong>
              </TableCell>
              <TableCell>
                <strong>Mobile</strong>
              </TableCell>
              <TableCell>
                <strong>Email</strong>
              </TableCell>
              <TableCell>
                <strong>Department</strong>
              </TableCell>
              <TableCell>
                <strong>Role</strong>
              </TableCell>
              <TableCell>
                <strong>Actions</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredStaffList && filteredStaffList.length > 0 ? (
              filteredStaffList
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((staff, index) => (
                  <TableRow key={staff._id || index}>
                    <TableCell sx={{ color: "white", paddingY: "5px" }}>
                      {staff.staffID}
                    </TableCell>
                    <TableCell sx={{ color: "white", paddingY: "5px" }}>
                      {staff.fullName}
                    </TableCell>
                    <TableCell sx={{ color: "white", paddingY: "5px" }}>
                      {staff.mobile}
                    </TableCell>
                    <TableCell sx={{ color: "white", paddingY: "5px" }}>
                      {staff.email}
                    </TableCell>
                    <TableCell sx={{ color: "white", paddingY: "0px" }}>
                      {staff.department?.map((item) => item.label).join(", ")}
                    </TableCell>
                    <TableCell sx={{ color: "white", paddingY: "5px" }}>
                      {staff.role}
                    </TableCell>
                    <TableCell
                      sx={{
                        display: "flex",
                        paddingY: "6px",
                      }}
                      align="center"
                    >
                      <Box direction="row" spacing={1} justifyContent="center">
                        <IconButton
                          onClick={() => handleView(staff)}
                          size="small"
                        >
                          <VisibilityIcon
                            sx={{
                              padding: "0",
                            }}
                            color="primary"
                          />
                        </IconButton>
                        <IconButton
                          onClick={() => handleEdit(page * rowsPerPage + index)}
                          size="small"
                        >
                          <EditIcon
                            sx={{
                              padding: "0",
                            }}
                            color="success"
                          />
                        </IconButton>
                        <IconButton
                          color="error"
                          onClick={() =>
                            handleDelete(page * rowsPerPage + index)
                          }
                          size="small"
                        >
                          <DeleteIcon
                            sx={{
                              padding: "0",
                            }}
                          />
                        </IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  No staff added yet.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <Box
          className="mui-wrapper mui-isolated-container p-0"
          sx={{
            color: "white",
            px: 2,
            py: 1,
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            borderTop: "1px solid #ccc",
          }}
        >
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredStaffList?.length || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
              background: "#8d8787",
              borderRadius: "0px",
              color: "white !important",
              ".MuiTablePagination-toolbar": {
                m: 0,
                color: "white",
                overflow: {
                  xs: "scroll",
                  sm: "hidden",
                },
              },
              ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows":
                {
                  color: "white !important",
                },
            }}
          />
        </Box>
      </TableContainer>

      <Modal show={showModal} onHide={handleClose} backdrop="static" centered>
        <Modal.Header
          closeButton
          className="bg-dark text-white"
          closeVariant="white"
        >
          <Modal.Title>
            {editingIndex !== null ? "Edit Staff" : "Add Staff"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-dark text-white">
          <Form>
            {userType === "user" ? (
              <Form.Group className="mb-3">
                <Form.Label>User ID</Form.Label>
                <Form.Control
                  type={editingIndex !== null ? "text" : "number"}
                  readOnly={editingIndex !== null}
                  placeholder="User ID"
                  name="staffID"
                  value={formData.staffID}
                  required
                  onChange={handleChange}
                  className="bg-secondary text-white border-0"
                />
              </Form.Group>
            ) : (
              <Form.Group className="mb-3">
                <Form.Label>Employee ID</Form.Label>
                <Form.Control
                  type={editingIndex !== null ? "text" : "number"}
                  readOnly={editingIndex !== null}
                  placeholder="Employee ID"
                  name="staffID"
                  value={formData.staffID}
                  required
                  onChange={handleChange}
                  className="bg-secondary text-white border-0"
                />
              </Form.Group>
            )}

            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                name="fullName"
                placeholder="Enter name"
                value={formData.fullName}
                required
                onChange={handleChange}
                className="bg-secondary text-white border-0"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Mobile</Form.Label>
              <Form.Control
                type="tel"
                name="mobile"
                placeholder="Enter mobile"
                value={formData.mobile}
                required
                onChange={handleChange}
                className="bg-secondary text-white border-0"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                placeholder="Enter email"
                required
                value={formData.email}
                onChange={handleChange}
                className="bg-secondary text-white border-0"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                name="password"
                placeholder="Enter Password"
                required
                value={formData.password}
                onChange={handleChange}
                className="bg-secondary text-white border-0"
              />
            </Form.Group>
            {
              <FormControl fullWidth className="mb-3 p-0">
                <Form.Label>Department</Form.Label>
                <Select
                  multiple
                  value={formData.department.map((d) => d._id)}
                  onChange={handleSelectChange}
                  size="small"
                  input={<OutlinedInput notched={false} label="" />}
                  className="bg-secondary text-white border-0"
                  sx={{
                    minWidth: 200, // optional: set a minimum width
                    fontSize: "0.875rem", // smaller font
                    p: 0.2, // reduce padding
                  }}
                  renderValue={(selected) =>
                    selected
                      .map((id) => {
                        const dept = departments.find((dep) => dep._id === id);
                        return dept ? dept.label : id;
                      })
                      .join(", ")
                  }
                >
                  {departments.map((dept) => (
                    <MenuItem key={dept._id} value={dept._id}>
                      <Checkbox
                        checked={formData.department.some(
                          (d) => d._id === dept._id
                        )}
                        size="small" // <-- checkbox also small
                      />
                      <ListItemText primary={dept.label} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            }
          

<FormControl fullWidth className="mb-3 p-0">
  <Form.Label>Allowed Modules</Form.Label>
  <Select
    multiple
    value={formData.allowedModule || []} // default to empty array
    onChange={(e) =>
      setFormData({
        ...formData,
        allowedModule: e.target.value,
      })
    }
    size="small"
    input={<OutlinedInput notched={false} label="" />}
    className="bg-secondary text-white border-0"
    sx={{
      minWidth: 200,
      fontSize: "0.875rem",
      p: 0.2,
    }}
    renderValue={(selected) => (selected || []).join(", ")}
  >
    {["Dashboard",
      "Departments",
      "Staff Management",
      "User",
      "Clients",
      "Vendors",
      "Category",
      "Tickets","Reports"
    ].map((module) => (
      <MenuItem key={module} value={module}>
        <Checkbox
          checked={formData.allowedModule?.includes(module) || false}
          size="small"
        />
        <ListItemText primary={module} />
      </MenuItem>
    ))}
  </Select>
</FormControl>


          </Form>
        </Modal.Body>
        <Modal.Footer className="bg-dark">
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSave} disabled={loading}>
            {loading ? (
              <CircularProgress size={24} sx={{ color: "white" }} />
            ) : editingIndex !== null ? (
              "Update"
            ) : (
              "Add"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
      <SnackNotification
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        handleClose={handleSnackbarClose}
      />

      <Modal show={showViewModal} onHide={handleViewClose}>
        <Modal.Header closeButton>
          <Modal.Title>Staff Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {viewStaff && (
            <div>
              <p>
                <strong>Employee ID:</strong> {viewStaff.staffID}
              </p>
              <p>
                <strong>Name:</strong> {viewStaff.fullName}
              </p>
              <p>
                <strong>Email:</strong> {viewStaff.email}
              </p>
              <p>
                <strong>Mobile:</strong> {viewStaff.mobile}
              </p>
              <p>
                <strong>Departments:</strong>{" "}
                {viewStaff.department && viewStaff.department.length > 0
                  ? viewStaff.department
                      .map((d) => {
                        const dept = departments.find(
                          (dep) => dep._id === d._id
                        );
                        return dept ? dept.label : d._id;
                      })
                      .join(", ")
                  : "No Department"}
              </p>
              <p>
                <strong>Employee Role:</strong> {viewStaff.role}
              </p>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default StaffManagement;
